import { render, staticRenderFns } from "./templateDetailDialog.vue?vue&type=template&id=5faaa239&scoped=true"
import script from "./templateDetailDialog.vue?vue&type=script&lang=js"
export * from "./templateDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./templateDetailDialog.vue?vue&type=style&index=0&id=5faaa239&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faaa239",
  null
  
)

export default component.exports